<template>
    <!-- /**
 * 質問コンポーネント
 * 質問(or テスト)のjsonを読み込んでうまく表示
 */ -->
    <div class="question">
        <div
            v-for="question in questions"
            :key="question.number"
            class="questionnaire"
        >
            <div class="question">
                {{ question.statement }}
            </div>
            <div
                v-for="choice in question.choices"
                :key="choice.value"
                class="form-check"
            >
                <input
                    type="radio"
                    :name="question.number"
                    :id="choice.value"
                    :value="choice.value"
                    :disabled="answered"
                    v-model="selected[question.number]"
                />
                <label :for="choice.value">{{ choice.statement }}</label>
            </div>
            <div v-if="testMode">
                <div v-show="answered" class="h4 border-top mt-4 pt-4 pb-3">
                    {{ result[question.number] }}
                </div>
                <div v-show="answered">{{ question.answer.statement }}</div>
            </div>
        </div>
        <button
            v-show="!answered"
            class="btn btn-primary mb-5 pe-auto"
            :disabled="!allSelected"
            @click="answer"
        >
            解答する
        </button>
        <router-link v-show="answered" class="btn btn-primary mb-5" to="/">
            項目選択画面に戻る
        </router-link>
    </div>
</template>

<script>
export default {
    name: "question",
    props: {
        /*
        questions: array of json
        +
        number: 問題番号
        statement: 問題文
        choices:
            value: 選択肢の値,
            statement: 選択肢文章

        answer:
            value: 正解の選択肢の値,
            statement: 解説文
        */
        questions: {
            type: Array,
            required: true,
        },
        // 選択したもの
        tmpSelected: {
            type: Object,
            required: true,
        },
        // 回答結果
        tmpResult: {
            type: Object,
            required: true,
        },
        // テスト編かどうか
        testMode: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            answered: false, // 回答済み
            // propsは編集できないため
            // dataプロパティに格納
            selected: this.tmpSelected,
            result: this.tmpResult,
            isClear: true,
        };
    },
    computed: {
        // 全選択したか
        allSelected() {
            return (
                this.selected.q1 != "" &&
                this.selected.q2 != "" &&
                this.selected.q3 != ""
            );
        },
    },
    methods: {
        answer() {
            if (this.testMode) {
                this.questions.forEach((item) => {
                    if (item.number == "q1") {
                        if (item.answer.value == this.selected["q1"]) {
                            this.result.q1 = `正解！ 答え：${item.answer.value.slice(
                                1
                            )}番目`;
                        } else {
                            this.result.q1 = `不正解... 答え：${item.answer.value.slice(
                                1
                            )}番目`;
                            this.isClear = false;
                        }
                    }
                    if (item.number == "q2") {
                        if (item.answer.value == this.selected["q2"]) {
                            this.result.q2 = `正解！ 答え：${item.answer.value.slice(
                                1
                            )}番目`;
                        } else {
                            this.result.q2 = `不正解... 答え：${item.answer.value.slice(
                                1
                            )}番目`;
                            this.isClear = false;
                        }
                    }
                    if (item.number == "q3") {
                        if (item.answer.value == this.selected["q3"]) {
                            this.result.q3 = `正解！ 答え：${item.answer.value.slice(
                                1
                            )}番目`;
                        } else {
                            this.result.q3 = `不正解... 答え：${item.answer.value.slice(
                                1
                            )}番目`;
                            this.isClear = false;
                        }
                    }
                });
            } else {
                // TODO: 回答結果をサーバに保存するapi
                this.$router.push("/");
            }
            this.answered = true;
            this.$store.commit("setCompleteStatus", {
                contents:
                    this.$route.params.contents.substring(0, 1).toUpperCase() +
                    this.$route.params.contents.substring(1),
                page: "test",
                isComplete: this.isClear,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.questionnaire {
    margin-bottom: 10px;
    padding: 24px;
    border: 1px solid #dadce0;
    border-radius: 12px;
}

.question {
    margin-bottom: 15px;
}

.form-check {
    padding-top: 18px;
    padding-left: 0;
}

input[type="radio"] {
    display: none;
}

label {
    padding: 0 0 0 30px;
    font-size: 15px;
    display: inline-block;
    cursor: pointer;
    position: relative;
    vertical-align: top;
}

label:before {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 25px;
    height: 25px;
    pointer-events: none;
    content: "";
    background-color: #fff;
    border: #202124 solid 2px;
    border-radius: 50%;
    transition: all 0.3s ease;
    transition-property: transform, border-color;
}

label:after {
    transform: scale(0);
}

input[type="radio"]:checked + label:before {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 25px;
    height: 25px;
    pointer-events: none;
    content: "";
    background-color: #fff;
    border: #1a73e8 solid 2px;
    border-radius: 50%;
    animation: #1a73e8 0.2s linear forwards;
}

input[type="radio"]:checked + label:after {
    position: absolute;
    top: 6px;
    left: 6px;
    width: 13px;
    height: 13px;
    content: "";
    background: no-repeat 50%/50% 50%;
    background-color: #1a73e8;
    border-radius: 50%;
    /* transition: transform ease .28s; */
    transform: scale(1);
}
</style>